(() => {
  if (customElements.get('niihai-collection-view')) return;
  const key = 'niihai_collection_layout';
  let mode = 'standard';
  try { mode = localStorage.getItem(key) === 'editorial' ? 'editorial' : 'standard'; } catch {}
  class CollectionView extends HTMLElement {
    connectedCallback() {
      this.section = this.dataset.context === 'breadcrumb'
        ? document.querySelector('.shopify-section--main-collection')
        : document.getElementById(`shopify-section-${this.dataset.sectionId}`) || this.closest('.shopify-section');
      if (!this.section || this.abort) return;
      const grid = this.section.querySelector('.product-list');
      if (grid?.id) this.querySelectorAll('[data-collection-view]').forEach(button => button.setAttribute('aria-controls', grid.id));
      this.abort = new AbortController();
      document.addEventListener('niihai:collection-layout-select', () => this.apply(), {signal: this.abort.signal});
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-collection-view]');
        if (!button || !this.contains(button)) return;
        mode = button.dataset.collectionView;
        try { localStorage.setItem(key, mode); } catch {}
        document.dispatchEvent(new CustomEvent('niihai:collection-layout-select'));
      }, { signal: this.abort.signal });
      this.observer = new MutationObserver(() => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.apply());
      });
      this.observer.observe(this.section, { childList: true, subtree: true });
      this.apply();
    }
    apply() {
      this.section.dataset.niihaiCollectionView = mode;
      this.querySelectorAll('[data-collection-view]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.collectionView === mode));
      });
      // Keep photo-only links named when the visible product headings are hidden.
      this.section.querySelectorAll('.product-list > .product-card').forEach(card => {
        const link = card.querySelector('.product-card__media');
        const heading = card.querySelector('.product-card__info a');
        if (link && heading) link.setAttribute('aria-label', heading.textContent.trim());
      });
      document.dispatchEvent(new CustomEvent('niihai:collection-view-change'));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('niihai-collection-view', CollectionView);
})();
